import React from "react"
import PropTypes from "prop-types"
import "./styles/ShowMore.css"
import {FormattedMessage} from "@irati/utils/lang"

const ShowMore = ({isShowingMore, handleShowMoreClick, displayShowMoreText}) => (
  <div>
    {displayShowMoreText ? (
      <div className="categoryTagsShowMore" onClick={() => handleShowMoreClick()}>
        <div className="categoryTagsShowMore_horizontalDivide" />
        <span className="categoryTagsShowMore_text">
          <FormattedMessage
            id={isShowingMore ? "perks.components.categories.showMore.showLess" : "perks.components.categories.showMore.showMore"}
          />
          <i className={isShowingMore ? "fa fa-chevron-up chevron" : "fa fa-chevron-down chevron"} />
        </span>
        <div className="categoryTagsShowMore_horizontalDivide" />
      </div>
    ) : (
      <div className="categoryTagsShowMore_horizontalDivide" />
    )}
  </div>
)

ShowMore.propTypes = {
  isShowingMore: PropTypes.bool,
  handleShowMoreClick: PropTypes.func,
  displayShowMoreText: PropTypes.bool
}

ShowMore.defaultProps = {
  isShowingMore: false,
  handleShowMoreClick: () => {},
  displayShowMoreText: false
}

export default ShowMore
